import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Initialize Sentry - minimal configuration for Angular 21 compatibility
// Only initialize if DSN is configured and valid
if (environment.sentryDsn && !environment.sentryDsn.startsWith('__')) {
    Sentry.init({
        dsn: environment.sentryDsn,
        environment: environment.sentryEnvironment,
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of transactions
    });
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
